import * as React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

export default function BodyWidgetMenu(props: {
    menuTitle: string,
    menuItems: ({ handler: () => void, title: string })[]
}) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: any) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div>
            <Button
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
            >
                {props.menuTitle}
            </Button>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                {props.menuItems.map((v: { handler: () => void, title: string }, index: number) => {
                    return <MenuItem key={`menu-item-${index}`} onClick={() => {
                        if (v.handler) {
                            v.handler();
                        }
                        handleClose();
                    }}>{v.title}</MenuItem>
                })}
            </Menu>
        </div>
    );
}
